var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 303",
    cx: 7.75,
    cy: 7.75,
    r: 7,
    fill: "#565B69"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon_hub"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.1478 6.68855L7.92438 3.9746C7.8046 3.87346 7.62846 3.87683 7.5122 3.9746L4.35216 6.68855C4.28523 6.74586 4.25 6.82677 4.25 6.91106V10.9533C4.25 11.1185 4.39092 11.25 4.56002 11.25H6.34612C6.51875 11.25 6.65614 11.1151 6.65614 10.9533V8.68102C6.65614 8.51583 6.79706 8.38434 6.96615 8.38434H8.50918C8.68181 8.38434 8.8192 8.5192 8.8192 8.68102V10.9533C8.8192 11.1185 8.96012 11.25 9.13274 11.25H10.9365C11.1091 11.25 11.25 11.1151 11.25 10.9533V6.91106C11.25 6.82677 11.2112 6.74249 11.1443 6.68855H11.1478Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHub);
export default __webpack_public_path__ + "static/media/icon_hub.9cf2b0dd006eb968b40078af0e4b8654.svg";
export { ForwardRef as ReactComponent };